import { useEffect, useState } from 'react';
import Script from 'react-load-script';

import { logger } from '@app/libs/logger';

interface LoadPortoneScriptProps {
  shopId: string;
  onLoad: () => void;
  onError: () => void;
}

function LoadPortoneScript({ shopId, onLoad, onError }: LoadPortoneScriptProps) {
  const [isLoadPortone, setLoadPortone] = useState(false);

  useEffect(() => {
    if (isLoadPortone) {
      const { IMP } = window;
      IMP.init(shopId);
    }
  }, [shopId, isLoadPortone]);

  function handleScriptErrorPortone() {
    setLoadPortone(false);
    onError();
    logger.error('fail to load portone script');
  }

  function handleScriptLoadPortone() {
    setLoadPortone(true);
    onLoad();
  }

  return (
    <>
      {!isLoadPortone && (
        <Script
          url="https://cdn.iamport.kr/v1/iamport.js"
          onError={handleScriptErrorPortone}
          onLoad={handleScriptLoadPortone}
        />
      )}
    </>
  );
}

export default LoadPortoneScript;
